import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'first-meeting-template',
  templateUrl: './first-meeting-template.component.html',
  styleUrls: ['../../../meeting-form.component.scss']
})
export class FirstMeetingTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
